import React, { useState, useMemo } from 'react'
import InvalidDateRangeModal from './modaldetailsmap/InvalidDateRangeModal'
import NoActivityRecordsModal from './modaldetailsmap/NoActivityRecordsModal'
import InvalidCoordinatesModal from './modaldetailsmap/InvalidCoordinatesModal'
import GeoCardMapModal from './modaldetailsmap/GeoCardMapModal'
import ReportGeofenceCard from '../unified/components/ReportGeofenceCard'
import {
  getLastActivityTime,
  assignClientIndicesAndFilter,
  allCoordinatesValid
} from '../../helpers/utils'

const GeoCardShowMap = ({
  geoData,
  data = [],
  user_name,
  startDate,
  endDate,
  renderCard,
  onLoadData,
  isMobileLayout = false
}) => {
  const [show, setShow] = useState(false)
  const [hasLoadError, setHasLoadError] = useState(false)

  const handleShow = async () => {
    setHasLoadError(false)
    try {
      await onLoadData?.()
    } catch (error) {
      if (error?.name !== 'AbortError') {
        setHasLoadError(true)
      }
    }
    setShow(true)
  }
  const handleClose = () => {
    setShow(false)
    setHasLoadError(false)
  }

  const lastActivityTime = useMemo(() => getLastActivityTime(data), [data])
  const processedData = useMemo(() => assignClientIndicesAndFilter(data), [data])
  const isDateRangeInvalid = startDate !== endDate
  const hasAllInvalidCoordinates = allCoordinatesValid(data)

  let ModalComponent = GeoCardMapModal
  if (hasLoadError) {
    ModalComponent = GeoCardMapModal
  } else if (isDateRangeInvalid) {
    ModalComponent = InvalidDateRangeModal
  } else if (data.length === 0) {
    ModalComponent = NoActivityRecordsModal
  } else if (hasAllInvalidCoordinates) {
    ModalComponent = InvalidCoordinatesModal
  }

  return (
    <div style={{ height: '100%' }}>
      {renderCard ? (
        renderCard({ onExpand: handleShow })
      ) : (
        <ReportGeofenceCard
          title="Actividades dentro de geocerca"
          value={geoData}
          onExpand={handleShow}
        />
      )}
      <ModalComponent
        show={show}
        handleClose={handleClose}
        {...{ startDate, endDate, lastActivityTime, data, processedData }}
        username={user_name}
        isMobileLayout={isMobileLayout}
        hasLoadError={hasLoadError}
        onRetry={handleShow}
      />
    </div>
  )
}

export default React.memo(GeoCardShowMap)
